import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/shared/context/useAuth";

export default function CaseTab({
  value,
  setValue,
}: {
  value: Number;
  setValue: React.Dispatch<React.SetStateAction<Number>>;
}) {
  const { t } = useTranslation();

  const { isOrgAdmin } = useAuth();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabStyle = {
    py: "0px",
    px: "15px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    backgroundColor: "white",
    color: "#3D3D3D !important",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F5F5F5 !important",
    },
    "&.Mui-selected": {
      backgroundColor: "#E0E0E0 !important",
      color: "#3D3D3D !important",
      fontWeight: "normal !important",
      "&:hover": {
        backgroundColor: "#E0E0E0 !important",
      },
    },
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          padding: "8px 0",
          "& .MuiTabs-flexContainer": {
            gap: "0",
          },
        }}
        TabIndicatorProps={{
          style: { display: "none" },
        }}
      >
        <Tab
          label={t("Οι Υποθέσεις μου")}
          value={0}
          disableRipple
          sx={tabStyle}
        />
        {isOrgAdmin && (
          <Tab
            label={t("Υποθέσεις στην Υ.Γ.Ε.ΜΗ. μου")}
            value={1}
            disableRipple
            sx={tabStyle}
          />
        )}
      </Tabs>
    </Box>
  );
}
